import type { CountryAlpha2 } from '@app/types';

export const maskRules: Record<CountryAlpha2, Array<[RegExp, string]>> = {
  RU: [
    [/[^\d+*]/g, ''],
    [/^7/, '+7'],
    [/^(\+7)(\d)/, '+7 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{5})(\d)/, '$1-$2'],
    [/(\d{3})(\d)/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  KZ: [
    [/[^\d+*]/g, ''],
    [/^7/, '+7'],
    [/^(\+?7)(\d)/, '+7 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{5})(\d)/, '$1-$2'],
    [/(\d{3})(\d)/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  US: [
    [/[^\d+*]/g, ''],
    [/^1/, '+1'],
    [/^(\+?1)(\d)/, '+1 ($2'],
    [/(\d{3})(\d)/, '$1)$2'],
    [/(\d{3})(\d)/, '$1-$2'],
    [/(\d{4})(\d)/, '$1$2'],
    [/^(.{30}).*/, '$1'],
  ],
  AM: [
    [/[^\d+*]/g, ''],
    [/^374/, '+374'],
    [/^(\+?374)(\d)/, '+374 $2'],
    [/(\d{2})(\d{2})/, '$1 $2'],
    [/(\d{6})(\d)/, '$1$2'],
    [/^(.{30}).*/, '$1'],
  ],
  AE: [
    [/[^\d+*]/g, ''],
    [/^971/, '+971'],
    [/^(\+?971)(\d)/, '+971 ($2'],
    [/(\d{2})(\d{3})/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/(\d{6})(\d)/, '$1$2'],
    [/^(.{30}).*/, '$1'],
  ],
  UA: [
    [/[^\d+*]/g, ''],
    [/^380/, '+380'],
    [/^(\+?380)(\d)/, '+380 $2'],
    [/(\d{2})(\d{2})/, '($1) $2'],
    [/(\d{5})(\d)/, '$1-$2'],
    [/(\d{3})(\d)/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  BY: [
    [/[^\d+*]/g, ''],
    [/^375/, '+375'],
    [/^(\+?375)(\d)/, '+375 ($2'],
    [/(\d{2})(\d{2})/, '$1) $2'],
    [/(\d{5})(\d)/, '$1-$2'],
    [/(\d{3})(\d)/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  IT: [
    [/[^\d+*]/g, ''],
    [/^39/, '+39'],
    [/^(\+?39)(\d)/, '+39 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  GR: [
    [/[^\d+*]/g, ''],
    [/^30/, '+30'],
    [/^(\+?30)(\d)/, '+30 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  DE: [
    [/[^\d+*]/g, ''],
    [/^49/, '+49'],
    [/^(\+?49)(\d)/, '+49 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  GB: [
    [/[^\d+*]/g, ''],
    [/^44/, '+44'],
    [/^(\+?44)(\d)/, '+44 $2'],
    [/(\d{4})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  KG: [
    [/[^\d+*]/g, ''],
    [/^996/, '+996'],
    [/^(\+?996)(\d)/, '+996 ($2'],
    [/(\d{3})(\d{2})/, '$1) $2'],
    [/(\d{2})(\d{2})/, '$1-$2'],
    [/(\d{2})(\d{2})/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  HR: [
    [/[^\d+*]/g, ''],
    [/^385/, '+385'],
    [/^(\+?385)(\d)/, '+385 ($2'],
    [/(\d{2})(\d{2})/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  ID: [
    [/[^\d+*]/g, ''],
    [/^62/, '+62'],
    [/^(\+?62)(\d)/, '+62 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  LV: [
    [/[^\d+*]/g, ''],
    [/^371/, '+371'],
    [/^(\+?371)(\d)/, '+371 ($2'],
    [/(\d{2})(\d{2})/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  AZ: [
    [/[^\d+*]/g, ''],
    [/^994/, '+994'],
    [/^(\+?994)(\d)/, '+994 $2'],
    [/(\d{2})(\d{3})/, '$1 $2'],
    [/(\d{3})(\d)/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  RS: [
    [/[^\d+*]/g, ''],
    [/^381/, '+381'],
    [/^(\+?381)(\d)/, '+381 $2'],
    [/(\d{2})(\d{3})/, '$1 $2'],
    [/(\d{3})(\d)/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  LT: [
    [/[^\d+*]/g, ''],
    [/^370/, '+370'],
    [/^(\+?370)(\d)/, '+370 ($2'],
    [/(\d{2})(\d{3})/, '$1) $2'],
    [/(\d{3})(\d)/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  GE: [
    [/[^\d+*]/g, ''],
    [/^995/, '+995'],
    [/^(\+?995)(\d)/, '+995 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{2})(\d{2})/, '$1-$2'],
    [/(\d{2})(\d{2})/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  TR: [
    [/[^\d+*]/g, ''],
    [/^90/, '+90'],
    [/^(\+?90)(\d)/, '+90 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  EE: [
    [/[^\d+*]/g, ''],
    [/^372/, '+372'],
    [/^(\+?372)(\d)/, '+372 ($2'],
    [/(\d{2})(\d{3})/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  CA: [
    [/[^\d+*]/g, ''],
    [/^1/, '+1'],
    [/^(\+?1)(\d)/, '+1 ($2'],
    [/(\d{3})(\d)/, '$1)$2'],
    [/(\d{3})(\d)/, '$1-$2'],
    [/(\d{4})(\d)/, '$1$2'],
    [/^(.{30}).*/, '$1'],
  ],
  ES: [
    [/[^\d+*]/g, ''],
    [/^34/, '+34'],
    [/^(\+?34)(\d)/, '+34 ($2'],
    [/(\d{2})(\d{3})/, '$1) $2'],
    [/(\d{3})(\d{2})/, '$1-$2'],
    [/(\d{2})(\d{2})/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  FI: [
    [/[^\d+*]/g, ''],
    [/^0/, '+358'],
    [/^358/, '+358'],
    [/^(\+?358)(\d)/, '+358 $2'],
    [/(\d{2})(\d{3})/, '$1 $2'],
    [/(\d{3})(\d)/, '$1-$2'],
  ],
  CZ: [
    [/[^\d+*]/g, ''],
    [/^420/, '+420'],
    [/^(\+?420)(\d)/, '+420 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  AT: [
    [/[^\d+*]/g, ''],
    [/^43/, '+43'],
    [/^(\+?43)(\d)/, '+43 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  ME: [
    [/[^\d+*]/g, ''],
    [/^382/, '+382'],
    [/^(\+?382)(\d)/, '+382 ($2'],
    [/(\d{2})(\d{3})/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],

  MD: [
    [/[^\d+*]/g, ''],
    [/^373/, '+373'],
    [/^(\+?373)(\d)/, '+373 ($2'],
    [/(\d{2})(\d{3})/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],

  CY: [
    [/[^\d+*]/g, ''],
    [/^357/, '+357'],
    [/^(\+?357)(\d)/, '+357 ($2'],
    [/(\d{2})(\d{3})/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],

  BG: [
    [/[^\d+*]/g, ''],
    [/^359/, '+359'],
    [/^(\+?359)(\d)/, '+359 ($2'],
    [/(\d{2})(\d{3})/, '$1) $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  IL: [
    [/[^\d+*]/g, ''],
    [/^972/, '+972'],
    [/^(\+?972)(\d)/, '+972 ($2'],
    [/(\d{1})(\d{3})/, '$1) $2'],
    [/(\d{3})(\d{4})/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  BE: [
    [/[^\d+*]/g, ''],
    [/^0/, '+32'],
    [/^32/, '+32'],
    [/^(\+?32)(\d)/, '+32 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{7})(\d)/, '$1-$2'],
    [/(\d{9})(\d)/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  RO: [
    [/[^\d+*]/g, ''],
    [/^0/, '+40'],
    [/^40/, '+40'],
    [/^(\+?40)(\d)/, '+40 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{7})(\d)/, '$1-$2'],
    [/(\d{3})(\d)/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  PL: [
    [/[^\d+*]/g, ''],
    [/^48/, '+48'],
    [/^(\+?48)(\d)/, '+48 $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/(\d{3})(\d)/, '$1 $2'],
    [/^(.{30}).*/, '$1'],
  ],
  CN: [
    [/[^\d+*]/g, ''],
    [/^0/, '+86'],
    [/^86/, '+86'],
    [/^1(\d*)/, '+861$1'],
    [/^(\+?86)(\d)/, '+86 ($2'],
    [/(\d{3})(\d)/, '$1) $2'],
    [/(\d{4})(\d)/, '$1-$2'],
    [/(\d{4})(\d)/, '$1-$2'],
    [/^(.{30}).*/, '$1'],
  ],
  '---': [
    [/[^\d+*]/g, ''],
    [/^\+/, '+'],
    [/^(\d)/, '+$1'],
    [/(\d{2})(\d)/, '$1 ($2'],
    [/(\d{2})(\d)/, '$1) $2'],
    [/^(.{30}).*/, '$1'],
  ],
};
